import React, { useEffect } from "react";
import styled from "@mui/system/styled";
import { useCallCenterForm } from "../hooks/useCallCenterForm";

import TextField from "@mui/material/TextField";

const TextInput = styled(TextField)(() => ({
  padding: "4px",
}));

const LastName = () => {
  const { errors, formValues, handleInputChange, handleInputFocus } =
    useCallCenterForm();

  useEffect(() => {}, [formValues]);

  const handleErrorText = () => {
    if (!errors?.last_name) {
      return null;
    }

    return errors?.last_name;
  };

  return (
    <TextInput
      sx={{ flex: 1 }}
      name="last_name"
      label="Last Name"
      onChange={handleInputChange}
      onFocus={handleInputFocus}
      value={formValues.last_name}
      helperText={handleErrorText()}
      error={!!errors?.last_name}
    />
  );
};

export default LastName;
